require('./bootstrap');
require('./numeric-fields');
require('./fancy-select');
require('./form/serialize-element');
require('./form/validation');
require('./form/form');
require('./loan-calculator');
require('./faq');
require('./nav');
// require('./reviews');
require('./contact');
require('./components');
require('./cookies');
require('./help');
require('./slider');